import React, { useEffect,useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { withRouter } from 'react-router-dom';
import './SolutionInfoCard.scss';
import { Card, AvatarWrapper, Content, MultiToasts, Toast, TOAST_VISIBILITY_DURATIONS, TOAST_VARIANTS, TOAST_POSITIONS } from 'cdk-radial';
import {
  getSolutionInfo,
  preloadAppTerms,
  preloadAppTermsHeaders,
  savePreloadedTerms,
  getAPIProviders,
  getAPIProviderSelectedByAppPublisher,
  getDataRightsConsentSigningUrl,
  saveApiAndProviderRequiredForTheApp,
  getSignedS3Url,
  getEntityById,
  getAsyncAPIs,
  preloadDataRights
} from '../../redux/connectedComponent/solutionInfo/solutionInfo.slice';
import {removeSelectedRequiredfield} from '../../redux/connectedComponent/apiFields/apiFields.slice'

import {
  setLocationsAsPerApp,
  setAllLocationsAfterMergingCMFs,
  setProcessingDone
} from '../../redux/connectedComponent/loginDetails/loginDetails.slice';

import { mergeLocations } from '../../utils/location';

import { environmentURLs } from '../common/CaptureEnvironment';
import LearnMore from '../LearnMore/LearnMore';

const SolutionInfoCard = props => {
  const dispatch = useDispatch();
  const [toastContent, setToastContent] = useState('')
  const [toasts, setToasts] = useState([]);
  const addToast = toast => setToasts(prev => {
    if(prev.some((t)=> t.content.props.children[1].props.children === toast.content.props.children[1].props.children)){
      return prev
    } else {
      return [toast, ...prev]
    }
  });
  const removeToast = id => setToasts(prev => prev.filter(toast => toast.id !== id));
  const createToast = (apiName) => {
    const id = `id-${apiName}`;
    return {
      content: <span>You need to enable at least one field for <b>{apiName}</b> API to proceed.</span>,
      id,
      variant: TOAST_VARIANTS.NEGATIVE,
      visibilityDuration: TOAST_VISIBILITY_DURATIONS.INFINITE
    };
  };
  const state = useSelector(state => state);
  const token =
    state.loginDetailsSlice && state.loginDetailsSlice.authenticationToken;

  const solutionInfo = state.solutionInfoSlice.solutionInfo;
  const { isSolutionInfoSuccess } = state.solutionInfoSlice;

  const { appTermsSignedS3Url, appTermsHeadersSignedS3Url, captureDataRights } = state && state.solutionInfoSlice && state.solutionInfoSlice;
  const { allLocations, locationsProcessingDone } = state && state.loginDetailsSlice;
  const overview = solutionInfo && solutionInfo.overview;

  const solutionLogo = overview && overview.solutionLogo;
  const appName = overview && overview.name;
  const appPublisher = overview && overview.publisherName;
  const solutionId = props.solutionId || (props.match && props.match.params && props.match.params.solutionId);

  const appTermsAndConditionsUrl = overview && overview.termsAndConditionsUrl;

  const customConsentForm = solutionInfo.custom_consent && solutionInfo.custom_consent.customConsentForm;
  let customConsentFileName = '';
  const isAppNotListed = props.isAppNotListed;
  let orgInitials = '';

  if(customConsentForm){
    const consentUrl = customConsentForm.split('.com/');
    customConsentFileName = consentUrl && consentUrl[1];
  }

  const preLoadedAppTerms =
    state.solutionInfoSlice && state.solutionInfoSlice.preLoadedAppTerms;

  let api_details =
    solutionInfo &&
    solutionInfo.registration_details &&
    solutionInfo.registration_details.api_details &&
    solutionInfo.registration_details.api_details.length &&
    solutionInfo.registration_details.api_details;

  const listingVersion = solutionInfo && solutionInfo.listingVersion;

  const apiAndProviders =
    state.solutionInfoSlice && state.solutionInfoSlice.apiAndProviders;

  const apiProviderSelectedByAppPublisher =
    state.solutionInfoSlice &&
    state.solutionInfoSlice.apiProviderSelectedByAppPublisher;

  const isApiProvidersPending =
    state.solutionInfoSlice &&
    state.solutionInfoSlice.isApiProvidersPending;

  const isAsyncAPIsPending =
    state.solutionInfoSlice &&
    state.solutionInfoSlice.isAsyncAPIsPending;

  const asyncAPIs =
    state.solutionInfoSlice &&
    state.solutionInfoSlice.asyncAPIs;

  const fieldDetail = 
    state?.apiFieldsSlice &&
    state?.apiFieldsSlice?.fieldDetail  

  const allFieldsUncheckedApiList = state?.apiFieldsSlice?.allFieldsUncheckedApiList;

  async function getSolutionInfoWrapper() {
    dispatch(getSolutionInfo({solutionId, token}));
  }


  async function getSignedS3UrlWrapperAppTerms() {
    let appTermsFileName = appTermsAndConditionsUrl && appTermsAndConditionsUrl.split('.com/');
    appTermsAndConditionsUrl && dispatch(getSignedS3Url({type: 'appTerms', expires: 3600, fileName: appTermsFileName && appTermsFileName[1], token}));
    appTermsAndConditionsUrl && dispatch(getSignedS3Url({type: 'appTermsHeaders', operation: 'headObject', expires: 3600, fileName: appTermsFileName && appTermsFileName[1], token}))
  }

  async function getSignedS3UrlWrapperCCF() {
    if(customConsentForm) {
      dispatch(getSignedS3Url({type: 'customConsentForm', expires: 3600, fileName: encodeURIComponent(customConsentFileName), token}));
    }
  }

  async function getDataRightsConsentSigningUrlWrapper() {
    dispatch(getDataRightsConsentSigningUrl());
  }

  async function getAPIProvidersWrapper(apis, appId) {
    dispatch(getAPIProviders({ apis, appId, token }));
  }

  async function getAsyncAPIsWrapper(asyncApis, appId) {
    dispatch(getAsyncAPIs({asyncApis, appId, token}));
  }

  async function getAPIProviderSelectedByAppPublisherWrapper() {
    dispatch(
      getAPIProviderSelectedByAppPublisher({
        solutionId,
        token
      })
    );
  }

  async function saveApiAndProviderRequiredForTheAppWrapper(
    apiAndProviderRequiredByTheApp
  ) {
    dispatch(
      saveApiAndProviderRequiredForTheApp(
        apiAndProviderRequiredByTheApp
      )
    );
  }

  async function preloadAppTermsWrapper() {
    dispatch(preloadAppTerms(appTermsSignedS3Url));
  }

  async function preloadAppTermsHeadersWrapper() {
    dispatch(preloadAppTermsHeaders(appTermsHeadersSignedS3Url));
  }

  async function savePreloadedTermsWrapper(result) {
    dispatch(savePreloadedTerms(result));
  }

  async function preloadDataRightsWrapper() {
    let fileName = environmentURLs.DATA_RIGHTS_PDF.split('.com/')[1]
    dispatch(preloadDataRights({type: 'dataRights', expires: 3600, fileName , token}));
  }

  useEffect(() => {
    if (!isAppNotListed) {
      getSolutionInfoWrapper();
      getDataRightsConsentSigningUrlWrapper();
    }
  }, []);

  useEffect(()=>{
    if(solutionInfo && solutionInfo.orgId && !isAppNotListed ){
      dispatch(getEntityById({id:solutionInfo.orgId,token}));
    }
  },[solutionInfo.orgId]);

  useEffect(()=>{
    if(solutionInfo && solutionInfo.un_authorized_signon && solutionInfo.un_authorized_signon.isEnabled){
      dispatch(setLocationsAsPerApp({unAuthTitleEnabled:solutionInfo.un_authorized_signon.isEnabled}));
    }
    else if (isSolutionInfoSuccess){
      dispatch(setProcessingDone(true));
    }
  },[solutionInfo.un_authorized_signon, isSolutionInfoSuccess]);

  useEffect(()=>{
    if(locationsProcessingDone) {
      dispatch(setAllLocationsAfterMergingCMFs(mergeLocations(allLocations)));
    }
  },[isSolutionInfoSuccess, locationsProcessingDone]);

  useEffect(() => {
    if (
      fieldDetail &&
      Object.prototype.hasOwnProperty.call(fieldDetail, 'apiName')
    ) {
      setToastContent(
        `You have disabled the ${fieldDetail?.fieldName} for the ${fieldDetail?.apiName}`
      );
    }
  }, [fieldDetail]);

  useEffect(() => {
    if(allFieldsUncheckedApiList && allFieldsUncheckedApiList.length != 0 && allFieldsUncheckedApiList.length > toasts.length){
      allFieldsUncheckedApiList.forEach((e) => {
        addToast(createToast(e))
      })
    } 
    if(allFieldsUncheckedApiList && allFieldsUncheckedApiList.length < toasts.length) {
      let toastId;
      if(allFieldsUncheckedApiList.length != 0){
        toasts.forEach((e) => {
          if(allFieldsUncheckedApiList.find(a => `id-${a}` != e.id)){
            toastId = e.id;
          }
        })
      } else {
        toastId = toasts[0].id;
      }
      removeToast(toastId);
    }
  },[allFieldsUncheckedApiList?.length])

  useEffect(()=>{
    if(isSolutionInfoSuccess && captureDataRights){
      preloadDataRightsWrapper()
    }
},[isSolutionInfoSuccess,captureDataRights]);

  useEffect(() => {
    if (api_details) {
      let apis = [];
      let asyncApis = [];
      api_details.map(api => {
        if(api.apiType === 'async-api'){
          asyncApis.push(api.id)
        } else {
          apis.push(api.id);
        }
      });
      if(apis.length){
        getAPIProvidersWrapper(apis, solutionId);
      }
      if(asyncApis?.length){
        getAsyncAPIsWrapper(asyncApis, solutionId)
      }
    }
    if (listingVersion) {
      getAPIProviderSelectedByAppPublisherWrapper();
    }
  }, [api_details]);

  useEffect(() => {
    if (appTermsSignedS3Url) {
      preloadAppTermsWrapper();
      preloadAppTermsHeadersWrapper();
    }
  }, [appTermsSignedS3Url]);

  useEffect(() => {
    if (appTermsHeadersSignedS3Url) {
      preloadAppTermsHeadersWrapper();
    }
  }, [appTermsHeadersSignedS3Url]);

  useEffect(() => {
    getSignedS3UrlWrapperAppTerms();
  }, [appTermsAndConditionsUrl]);

  useEffect(() => {
    getSignedS3UrlWrapperCCF();
  }, [customConsentFileName]);

  useEffect(() => {
    if (
      preLoadedAppTerms &&
      typeof preLoadedAppTerms === 'object' &&
      preLoadedAppTerms instanceof Blob
    ) {
      const documentBlobObjectUrl = URL.createObjectURL(preLoadedAppTerms);
      savePreloadedTermsWrapper(documentBlobObjectUrl);
    }
  }, [preLoadedAppTerms]);

  useEffect(() => {

    if ((isApiProvidersPending || isAsyncAPIsPending) && ((!apiAndProviders.length && !apiProviderSelectedByAppPublisher.length) || !asyncAPIs.length)) {
      return;
    }

    let apiAndProviderRequired = []

    if(apiAndProviders.length && apiProviderSelectedByAppPublisher.length){
      let apiAndProviderRequiredByTheApp =
      apiProviderSelectedByAppPublisher.length &&
      apiProviderSelectedByAppPublisher.map(
        apiProviderSelectedByAppPublisher => {
          const api =
            apiAndProviders.length &&
            apiAndProviders.filter(
              apiAndProvider =>
                apiAndProvider.apiName ===
                apiProviderSelectedByAppPublisher.apiName
            );
          const apiProvider = api && api.length && api[0].apiProvider;
          return (
            apiProvider &&
            apiProvider.filter(
              apiAndProvider =>
                apiAndProvider.id ===
                apiProviderSelectedByAppPublisher.apiProvider.apiProviderId
            )
          );
        }
      );

      apiAndProviderRequiredByTheApp &&
      apiAndProviderRequiredByTheApp.length &&
      apiAndProviderRequiredByTheApp.map(apiAndProvider => {
        if (!apiAndProvider || !apiAndProvider.length) return;
        let apiProvider = apiAndProvider && apiAndProvider[0];
        let apiName = apiProvider && apiProvider.id;
        let api =
          api_details &&
          api_details.length &&
          api_details.filter(api => api.id === apiName);
        let apiDisplayName = api && api.length && api[0].displayName;
        let apiType = api && api.length && api[0].apiType;
        apiAndProviderRequired.push({ ...apiAndProvider[0], apiType, displayName: apiDisplayName });
      });
    }

    if(asyncAPIs?.length && apiProviderSelectedByAppPublisher.length) {
      let asyncAPIsRequiredByApp = [];
      apiProviderSelectedByAppPublisher.length &&
      apiProviderSelectedByAppPublisher.map(
        apiProviderSelectedByAppPublisher => {
          const api =
          asyncAPIs.find(
              apiAndProvider =>
                apiAndProvider.id ===
                apiProviderSelectedByAppPublisher.apiName
            );
          if(api){
            asyncAPIsRequiredByApp.push(api)
          }
        }
      );
      asyncAPIsRequiredByApp.length && asyncAPIsRequiredByApp.map(item => {
        const asyncApi =
          api_details &&
          api_details.length &&
          api_details.find(api => api.id === item.id);
        const apiDisplayName = asyncApi && asyncApi.displayName;
        const id = item.id;
        const name = asyncApi && asyncApi.providers[0].name;
        const apiType = asyncApi && asyncApi.apiType;
        const addendum = (item.terms && item.terms.length && item.terms.find(term => term.type === 'addendum')) || null;
        const addendumDoc = (addendum && addendum.url) || null;
        asyncApi && apiAndProviderRequired.push({
          id,
          api: item.id,
          apiType,
          name,
          addendum,
          addendumDoc,
          displayName: apiDisplayName,
          productName: apiDisplayName
        });
      });
    }
    saveApiAndProviderRequiredForTheAppWrapper(apiAndProviderRequired);
  }, [apiAndProviders, apiProviderSelectedByAppPublisher, asyncAPIs, isApiProvidersPending, isAsyncAPIsPending]);

  if(isAppNotListed)
  {
    let initials = props.orgName.split(' ');
      initials.forEach((split) => {
        orgInitials  += split.charAt(0).toUpperCase();
      });
      orgInitials = orgInitials.substring(0, 2);
  }

  return (
    <div className="solution-info-card">
      <div className="solution-info-card-container">
        <div className="solution-info-card-detail-container">
          <Card
            className={
              isAppNotListed
                ? 'solution-info-card-logo-unlisted-app'
                : 'solution-info-card-logo'
            }
          >
            {isAppNotListed ? (
              <AvatarWrapper className="org-logo-solution-header">
                <Content
                  style={{
                    color: 'white',
                  }}
                >
                  {orgInitials}
                </Content>
              </AvatarWrapper>
            ) : (
              <img
                src={props.solutionLogo || solutionLogo}
                alt="App Logo"
                className="solution-icon"
              ></img>
            )}
          </Card>
          <div className="solution-info-card-app-data">
            <div className="solution-info-card-app-name">
              {props.appName || appName}
            </div>
            <div className="solution-info-card-app-publisher">
              {props.publisherName || appPublisher}
            </div>
          </div>
        </div>
        {props.showLearnMore && !toastContent && (
          <div className="solution-info-card-learn-more">
            <LearnMore
              docPath="/docs/marketplace/marketplace-for-apps/activating-apps/"
              screen="App Activation"
            />
          </div>
        )}
        {toastContent && (
          <Toast
            content={toastContent}
            className="api-field-unchecked-toast"
            id="toast-1"
            onVisibilityDurationEnd={() => {
              setToastContent('');
              dispatch(removeSelectedRequiredfield());
            }}
            visibilityDuration={TOAST_VISIBILITY_DURATIONS.SIX_SECONDS}
            variant={TOAST_VARIANTS.POSITIVE}
            position={TOAST_POSITIONS.FIXED}
          />
        )}
        <>
          <MultiToasts items={toasts} position={TOAST_POSITIONS.FIXED} />
        </>
      </div>
    </div>
  );
};

export default withRouter(SolutionInfoCard);
